import '../../journey.scss';

import { Card } from '@transferz/fe-component-library/src/components/card/Card';
import Briefcase from '@transferz/fe-component-library/src/components/icons/BriefcaseIcon';
import CirclePlus from '@transferz/fe-component-library/src/components/icons/CirclePlusIcon';
import Notes from '@transferz/fe-component-library/src/components/icons/NotesIcon';
import User from '@transferz/fe-component-library/src/components/icons/UserIcon';
import Typography from '@transferz/fe-component-library/src/components/typography/Typography';
import { JourneyStatusType } from '@transferz/fe-models';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useLocalize } from 'localize-react';
import React, { useState } from 'react';

export const TransferDetails: React.FC<any> = ({ journey }) => {
  const { translate } = useLocalize();
  const flags = useFlags();
  const [isCollapsed, setIsCollapsed] = useState(journey?.status !== JourneyStatusType.Pending);

  const onCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <div className="transfer-company-details-wrapper card-wrap">
      <Card title={translate('transferDetailsTitle')} collapsed={isCollapsed} onCollapse={onCollapse}>
        <div className="transfer-details transfer-details-card">
          <div className="vehicle">
            <img alt="vehicle" src={`/transferz/vehicles/${journey?.journeyExecutionInfo?.vehicleCategory}.jpg`} />
            <div className="vehicle-type">
              <Typography variant="caption" color="asphalt6">
                {translate('vehicleType')}
              </Typography>
              <Typography variant="body1">
                {translate(journey?.journeyExecutionInfo?.vehicleCategory)}
              </Typography>
            </div>
          </div>
          <div className="details">
            <div className="d-flex mb-24">
              <div className="d-flex">
                <User />
                <Typography variant="body1">{journey?.travellerInfo?.passengerCount}</Typography>
              </div>
              <div className="d-flex">
                <Briefcase width="23" height="21" />
                <Typography variant="body1">{journey?.travellerInfo?.luggageCount}</Typography>
              </div>
            </div>
            <div className="mb-24">
              <div className="d-flex">
                <CirclePlus width="21" />
                <Typography variant="body1" color={journey?.travelAddons?.length ? 'dark' : 'asphalt4'}>
                  {
                    journey?.travelAddons?.length > 0
                      ? journey?.travelAddons?.map((addon: any, idx: number) => {
                        return `${translate(addon.type)}`;
                      }).join(', ')
                      : translate('transferDetails_noAddons')
                  }
                </Typography>
              </div>
            </div>
            <div className="mb-12">
              <div className="d-flex">
                <Notes />
                <Typography variant="body1" color={journey?.travellerInfo?.driverComments ? 'dark' : 'asphalt4'}>
                  {journey?.travellerInfo?.driverComments ? journey?.travellerInfo?.driverComments : translate('transferDetails_noDriverComment')}
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};
